import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./ThemeContext";
import LandingPage from "./LandingPage";
import AssignmentEvaluator from "./AssignmentEvaluator";
import CategoryDetail from "./CategoryDetail";
import TutorialDetail from "./TutorialDetail";
import AssignmentEvaluatorDetail from "./AssignmentEvaluatorDetail";
import AboutUs from "./AboutUs";
import ContactUs from "./ContactUs";

export default function App() {
  const globalStyles = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:wght@300;400;500;600&display=swap');
    
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    
    :root {
      --ink: #0f1117;
      --ink-soft: #4a4f5e;
      --ink-faint: #8b91a1;
      --bg: #f7f8fa;
      --surface: #ffffff;
      --border: #e4e6ed;
      --accent: #667eea;
    }
    
    html[data-theme="dark"] {
      --ink: #f7f8fa;
      --ink-soft: #cbd5e1;
      --ink-faint: #94a3b8;
      --bg: #0f1117;
      --surface: #1a1f3a;
      --border: #2d3748;
      --accent: #667eea;
    }
    
    html, body, #root {
      width: 100%;
      height: 100%;
    }
    
    body {
      font-family: 'DM Sans', sans-serif;
      background: var(--bg);
      color: var(--ink);
      line-height: 1.6;
      -webkit-font-smoothing: antialiased;
      transition: background-color .3s, color .3s;
    }
  `;

  return (
    <>
      <style>{globalStyles}</style>
      <ThemeProvider>
        <Router>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/tools/assignment-evaluator" element={<AssignmentEvaluator />} />
            <Route path="/category/:category" element={<CategoryDetail />} />
            <Route path="/tutorial/:id" element={<TutorialDetail />} />
            <Route path="/assignment-evaluator-detail" element={<AssignmentEvaluatorDetail />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUs />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </>
  );
}
